import { Link } from "react-router-dom";
import { renderStatus } from "../../../../Utils/CommonUtils";

const useProductColumns = () => {
  const productColumns = [
    {
      header: "Code",
      accessorKey: "code",
      cell: (props) => (
        <Link
          className="table-drilling-link"
          to={`/prod/product/update/${props.row.original.entityid}`}
        >
          {props?.getValue() ? props?.getValue() : "-"}
        </Link>
      ),
      size: 60,
    },
    // {
    //   header: "Created Date",
    //   accessorKey: "created_date",
    //   // cell: (props) => {
    //   //   {props?.getValue() ? props?.getValue() : "-"}
    //   // },
    //   size: 200,
    // },

    {
      header: "Name",
      accessorKey: "name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    // {
    //   header: "Product Type",
    //   accessorKey: "product_type",
    //   cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
    //   size: 200,
    // },
    {
      header: "Product/Service Category",
      accessorKey: "product_category",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: (props) =>
        props?.getValue() ? renderStatus(props?.getValue()) : "-",
      size: 160,
    },
  ];

  return { productColumns };
};
export default useProductColumns;
